/**
 * Modèles de missions ESS prêts à personnaliser.
 * Servent à préremplir les champs Objet + Résumé exécutif dans DossiersPage.
 */
export const MISSION_TEMPLATES = [
  {
    id: 'audit_ess',
    label: 'Audit ESS',
    icon: '🔍',
    objet:
      "Audit ESS d'une structure d'économie sociale et solidaire",
    resume:
      "Contexte — La structure sollicite un état des lieux complet de son fonctionnement, de sa gouvernance et de son modèle économique afin d'identifier les leviers de consolidation.\n\nEnjeux — Sécuriser la conformité juridique (statuts, agréments, instances), renforcer la lisibilité financière et mesurer l'impact social et territorial généré.\n\nObjectifs et étapes — 1) Cartographie des activités et des parties prenantes. 2) Diagnostic gouvernance, ressources humaines et modèle économique. 3) Restitution avec plan d'action priorisé et indicateurs de suivi.",
  },
  {
    id: 'appui_coop',
    label: 'Appui création coopérative',
    icon: '🌱',
    objet:
      "Appui à la création et structuration d'une coopérative (SCIC/SCOP)",
    resume:
      "Contexte — Les porteurs de projet souhaitent constituer une société coopérative pour formaliser un collectif engagé sur un territoire ultramarin, avec une gouvernance partagée.\n\nEnjeux — Choisir le bon statut (SCIC ou SCOP), sécuriser les statuts et le règlement intérieur, réunir les apports en capital et fédérer les futurs associés.\n\nObjectifs et étapes — 1) Étude de faisabilité et modèle économique. 2) Rédaction des statuts, du pacte associés et du business plan. 3) Formalités administratives, souscription des parts sociales et lancement opérationnel.",
  },
  {
    id: 'accompagnement_benevolat',
    label: 'Accompagnement bénévolat',
    icon: '🤝',
    objet:
      "Accompagnement à la structuration d'un engagement bénévole",
    resume:
      "Contexte — L'organisation souhaite formaliser et pérenniser son engagement bénévole afin de mieux mobiliser, reconnaître et fidéliser ses bénévoles.\n\nEnjeux — Clarifier les rôles et parcours bénévoles, sécuriser le cadre légal (assurance, RGPD, conventions), valoriser les compétences acquises.\n\nObjectifs et étapes — 1) Diagnostic des besoins et cartographie des missions bénévoles. 2) Rédaction du parcours d'accueil, des conventions et outils de suivi. 3) Formation des référents et mise en place d'un tableau de bord de la vie bénévole.",
  },
  {
    id: 'diagnostic_impact',
    label: "Diagnostic d'impact social",
    icon: '📊',
    objet:
      "Diagnostic d'impact social et environnemental",
    resume:
      "Contexte — La structure souhaite mesurer et valoriser l'impact généré par ses activités auprès de ses parties prenantes (bénéficiaires, financeurs, collectivités).\n\nEnjeux — Choisir une méthodologie robuste (SROI, ESUS, indicateurs ESS), collecter des données fiables et produire un rapport engageant pour la communication externe.\n\nObjectifs et étapes — 1) Théorie du changement et cadre d'évaluation. 2) Collecte quantitative et qualitative auprès des bénéficiaires. 3) Rapport d'impact et recommandations pour amplifier les effets positifs.",
  },
  {
    id: 'formation_gouvernance',
    label: 'Formation gouvernance coopérative',
    icon: '🎓',
    objet:
      "Formation à la gouvernance coopérative et démocratique",
    resume:
      "Contexte — Les instances de la structure souhaitent renforcer leurs pratiques démocratiques et professionnaliser le fonctionnement du conseil et de l'assemblée.\n\nEnjeux — Maîtriser les rôles et responsabilités des instances, animer des décisions collectives efficaces et prévenir les conflits d'intérêts.\n\nObjectifs et étapes — 1) Ateliers pratiques sur les statuts, les collèges et le vote pondéré. 2) Simulation d'AG et mise en situation d'arbitrages. 3) Livrable : charte de gouvernance et calendrier des instances.",
  },
];
